var _rect, _rect2, _rect3, _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRequirementCoverageActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.0968,
    y: 4,
    width: 6.19355,
    height: 2,
    rx: 1,
    fill: "#2940E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.0968,
    y: 8,
    width: 5.16129,
    height: 2,
    rx: 1,
    fill: "#2940E5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 13.4194,
    height: 14,
    rx: 2,
    stroke: "#2940E5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.8388,
    cy: 12.5,
    rx: 4.64516,
    ry: 4.5,
    fill: "white",
    stroke: "#2940E5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2903 12.5714L11.9202 14L17 9",
    stroke: "#2940E5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequirementCoverageActive);
export default __webpack_public_path__ + "static/media/requirement-coverage-active.2249126955316040bc8dd593174ca5d8.svg";
export { ForwardRef as ReactComponent };